export default {
  view: {
    back: {
      title1: 'Przyjęliśmy transakcję do&nbsp;realizacji!',
      title2: 'Dziękujemy, że jesteś z nami!',
      buttonTopup: 'Doładuj ponownie',
      buttonBack: 'Dalej'
    },
    backCreditCard: {
      title1: 'Twoja karta płatnicza została&nbsp;zweryfikowana!',
      title1a: 'Płatność powtarzalna BLIK została włączona',
      title2: 'Kolejne płatności za doładowania będą pobierane automatycznie.',
      titleVerify: 'Trwa przetwarzanie płatności',
      titleError: 'Nie udało się przetworzyć płatności!',
      buttonBack: 'Dalej',
      blikDescription: 'Potwierdź i utwórz płatność powtarzalną w aplikacji swojego banku.'
    },
    contacts: {
      header: 'Kontakty'
    },
    unregister: {
      loading: 'Zaczekaj. Trwa&nbsp;weryfikacja&nbsp;zgłoszenia...',
      title1ok: 'Dziękujemy za zgłoszenie.',
      title2ok: 'Twój kontakt został usunięty.<br>Nie będziesz otrzymywać tego typu wiadomości.<br>Pozdrawiamy!',
      title1error: 'Ups... Coś poszło nie tak.',
      title2error: 'Spróbuj jeszcze raz usunąć subskrypcję.',
      buttonTopup: 'Doładuj telefon'
    },
    userTerms: {
      loading: 'Trwa przetwarzanie danych...',
      header: 'Zaakceptuj regulamin konta',
      fieldTermsAgree: 'Zapoznałem się i akceptuję <a href="/files/plus/Regulamin-prowadzenia-konta-PLUS.pdf" target="_blank">Regulamin</a> prowadzenia konta w serwisie doladuj.plus.pl oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Politykę&nbsp;prywatności</a>',
      required: 'Pole wymagane',
      rodoText: 'Administratorem danych osobowych jest Autopay S.A. ul. Powstańców Warszawy 6, 81-718 Sopot. Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji płatności. Podstawa prawna, cel, okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Polityce prywatności Autopay S.A.</a>',
      buttonNext: 'Dalej',
      messges: {
        setTermsSuccess: 'Zgoda na regulamin została poprawnie zapisana!',
        setTermsError: 'Podczas próby zapisania zgody na regulamin wystąpił błąd!'
      }
    },
    history: {
      header: 'Historia doładowań'
    },
    userData: {
      header: 'Moje dane'
    }
  },
  component: {
    cookie: {
      text: 'Wyrażam zgodę na przechowywanie w moim urządzeniu plików cookies.',
      button: 'OK'
    },
    header: {
      linkLogin: 'Zaloguj',
      title: 'Doładowanie on-line Plus',
      loading: 'Pobieranie danych...',
      linkTopup: 'Doładuj',
      linkHistory: 'Historia',
      linkContacts: 'Kontakty',
      linkMyData: 'Moje dane',
      linkLogout: 'Wyloguj',
      a11y: {
        skipButton: 'Przejdź do treści głównej',
        hamburgerButton: 'Pokaż widok nawigacji',
        closeButton: 'Ukryj widok nawigacji',
        languages: {
          pl: 'Zmień język na polski',
          en: 'Zmień język na angielski',
          uk: 'Zmień język na ukraiński'
        },
        nav: {
          main: 'Przejdź do strony głównej',
          linkTopup: 'Przejdź do strony doładowania',
          linkHistory: 'Przejdź do strony historii doładowań',
          linkContacts: 'Przejdź do strony kontaktów',
          linkMyData: 'Przejdź do strony Moje dane',
          linkLogout: 'Wyloguj użytkownika'
        }
      }
    },
    autotopup: {
      progress: {
        step1: 'Typ doładowania',
        step2: 'Numer telefonu',
        step3: 'Aktywacja'
      },
      start: {
        header: 'Wybierz typ doładowania',
        topupSingle: 'Doładowanie jednorazowe',
        topupAuto: 'Doładowanie cykliczne',
        errorTypeRequired: 'Wybierz typ doładowania',
        buttonNext: 'Dalej',
        a11y: {
          nav: {
            topupTypeSingle: 'Przejdź do strony z formularzem doładowania jednorazowego',
            topupTypeAuto: 'Przejdź do strony z formularzem doładowania cyklicznego'
          }
        }
      },
      stage1: {
        title: '<strong>Krok 1</strong> - typ doładowania',
        header: 'Wybierz warunki doładowania',
        errorTypeRequired: 'Wybierz warunek doładowania',
        periodLabel: 'Co ile dni chcesz otrzymać doładowanie',
        dayLabel: 'Dzień doładowania',
        buttonNext: 'Dalej',
        fieldAmountLabel1: 'Doładuj konto kwotą',
        fieldAmountLabel2: 'zł',
        fieldPeriodLabel1: 'co',
        fieldPeriodLabel2: 'dni zaczynając od',
        fieldPeriodPlaceholder: 'data doładowania',
        fieldTopupDayLabel1: 'każdego',
        fieldTopupDayLabel2: 'dnia miesiąca',
        errorAmountRequired: 'Podaj kwotę doładowania',
        errorPeriodRequired: 'Podaj okres doładowania',
        errorNextTopupDayRequired: 'Podaj datę doładowania',
        a11y: {
          toNextStepButton: 'Przejdź do drugiego kroku w nowym widoku'
        }
      },
      stage2: {
        title: '<strong>Krok 2</strong> - numer telefonu',
        headerNoContacts: 'Dodaj numer do doładowania',
        header1: 'Wybierz numer z listy',
        header2: 'Lub dodaj numer do doładowania',
        contactCheckphoneError: 'Numer nie może być obecnie doładowany!',
        labelPhone: 'Numer telefonu, który chcesz doładować',
        errorPhoneRequired: 'Numer telefonu jest wymagany',
        errorPhoneInvalid: 'Numer telefonu jest nieprawidłowy',
        errorPhoneCheck: 'Numer telefonu nie może być doładowany',
        errorPhoneAutotopupActive: 'Numer telefonu ma już aktywne doładowanie cykliczne',
        labelName: 'Nazwa kontaktu',
        fieldNamePlaceholder: 'Nazwa kontaktu',
        errorNameRequired: 'Nazwa kontaktu jest wymagana',
        buttonNext: 'Dalej',
        buttonBack: 'Wróć',
        a11y: {
          toPreviousStepButton: 'Przejdź do pierszego kroku w nowym widoku',
          toNextStepButton: 'Przejdź do trzeciego kroku w nowym widoku'
        }
      },
      stage4: {
        title: '<strong>Krok 3</strong> - aktywacja doładowania',
        header: 'Wybierz formę płatności cyklicznej',
        creditCardInfo: 'Za chwilę poprosimy Cię o dodanie karty, z której cyklicznie będziemy pobierali wybraną przez Ciebie kwotę. Przygotuj wszystkie potrzebne dane: numer karty, datę ważności karty oraz kod CVV/CVC.',
        blikInfo: 'Za chwilę poprosimy Cię o aktywację płatności cyklicznej BLIK. Wygeneruj 6-cyfrowy kod BLIK w swojej aplikacji bankowej.',
        summaryHeader: 'Sprawdź, czy poniższe dane są poprawne.',
        topupInfoLabel: 'Informacje o doładowaniu',
        topupInfoType1Label: 'Typ doładowania',
        topupInfoType1Text: 'Doładowanie cykliczne',
        topupInfoType2Label: 'Zasada doładowania',
        topupInfoType2Text: 'Na podstawie daty',
        topupInfoAmountLabel: 'Kwota doładowania',
        topupInfoDayLabel: 'Dzień doładowania',
        topupInfoPeriodLabel: 'Okres doładowania',
        topupInfoPeriodText: 'co {day} dni',
        topupInfoNextDateLabel: 'Data doładowania',
        topupContactLabel: 'Dane kontaktu',
        topupContactPhoneLabel: 'Numer telefonu',
        topupContactNameLabel: 'Nazwa',
        agreementErrorHeader: 'Błąd pobrania regulaminu usługi',
        agreementErrorMessage: 'Przepraszamy, ale z przyczyn technicznych nie udało się pobrać regulaminu usługi. Spróbuj ponownie za jakiś czas.',
        agreementText: '<span class="red">*</span> Zapoznałem się i akceptuję <a href="{regulationUrl}" target="_blank">Regulamin automatycznych doładowań telefonów</a> oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Politykę&nbsp;prywatności</a>.',
        paymentText: '<span class="red">*</span> Chcę, aby usługa została zrealizowana niezwłocznie i przyjmuję do wiadomości, że w przypadku pełnego wykonania usługi, z chwilą jej wykonania, utracę prawo do odstąpienia od umowy.',
        termsText: '<span class="red">*</span> Wyrażam zgodę na cykliczne obciążanie przez Autopay S.A. mojej karty płatniczej w stałych kwotach wynikających z wybranego nominału doładowania telefonu, zgodnie z <a href="{regulationUrl}" target="_blank">Regulaminem automatycznych doładowań telefonu</a>. Karta płatnicza będzie obciążana z częstotliwością wybraną przeze mnie w serwisie "Doładowania on-line Plus", do czasu złożenia rezygnacji z cyklicznego obciążenia karty. Przyjmuję do wiadomości, że jestem uprawniony do rezygnacji z cyklicznego obciążenia karty płatniczej w sposób określony w <a href="{regulationUrl}" target="_blank">Regulaminie automatycznych doładowań telefonu</a>. W razie jakichkolwiek zapytań związanych z automatycznymi doładowaniami, należy kontaktować się z Działem Obsługi Klienta Autopay S.A. w sposób wskazany w <a href="{regulationUrl}" target="_blank">Regulaminie automatycznych doładowań telefonu</a>.',
        required: 'pole wymagane',
        buttonNext: 'Dalej',
        buttonBack: 'Wróć',
        paymentMethodCard: 'Karta płatnicza',
        paymentMethodBlik: 'Płatności powtarzalne BLIK',
        messges: {
          addTopupErrorHeader: 'Błąd!',
          addTopupError: 'Nie udało się zapisać doładowania cyklicznego!',
          addTopupSuccess: 'Doładowanie cykliczne zapisane!'
        },
        a11y: {
          toPreviousStepButton: 'Przejdź do drugiego kroku w nowym widoku',
          submitButton: 'Przejdź do nowej strony z platnością'
        }
      }
    },
    blik: {
      header: 'Płatności powtarzalne BLIK',
      loadingText: 'Wczytywanie danych...',
      verifyText1: 'Aby aktywować płatności powtarzalne BLIK wprowadź 6-cyfrowy kod BLIK z aplikacji swojego banku.',
      verifyText2: 'Teraz zapłacisz 1 zł, żebyśmy mogli włączyć płatności powtarzalne BLIK. Później zwrócimy Ci tę kwotę.',
      descriptionText: 'Aby zrealizować to zamówienie, potrzebujemy Twoich danych. Poprzez kliknięcie „Zapłać”, decydujesz się na przekazanie nam ich. Administratorem Twoich danych osobowych jest Autopay z siedzibą w Sopocie ul. Powstańców Warszawy 6, 81-718. Informacje o podstawie prawnej, celu i okresie, w którym będziemy przechowywać twoje dane oraz uprawnieniach, które Ci (jako Użytkownikowi) przysługują, znajdziesz w <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityce prywatności Autopay S.A.</a>',
      blikDescription: 'Aktywujesz "Płatności powtarzalne BLIK" dla Twojego konta. Tą metodą płatności możesz opłacać doładowania cykliczne. Samodzielnie ustalasz kwotę i częstotliwość pobierania opłat za doładowania cykliczne. Możesz włączyć je dla dowolnego numeru telefonu zapisanego w serwisie - teraz lub w przyszłości. Możesz aktywować płatności powtarzalne BLIK w&nbsp;następujących bankach:',
      labelBlik: 'Podaj kod BLIK',
      placeholderBlik: 'kod BLIK',
      buttonNext: 'Zapłać',
      errorFieldRequired: 'Pole wymagane',
      errorFieldPattern: 'Kod BLIK musi się składać z 6 cyfr',
      errorBankNotSupported: 'Nie możesz uruchomić Płatności powtarzalnej BLIK ponieważ usługa ta nie jest wspierana przez Twój bank. Sprawdź listę dostępnych banków.',
      summary: {
        nameLabel: 'Nazwa',
        nameValue: 'płatność cykliczna',
        amountLabel: 'Kwota doładowania',
        amountValue: 'dowolna',
        frequencyLabel: 'Częstotliwość',
        frequencyValue: 'dowolna',
        payLabel: 'Teraz zapłacisz',
        payValue: '1 zł'
      },
      messges: {
        addTokenSuccessHeader: 'Sukces!',
        addTokenSuccess: 'Twoja Płatność powtarzalna BLIK jest przetwarzana. Za chwilę będzie widoczna w sekcji Moje dane.',
        addTokenErrorHeader: 'Błąd!',
        addTokenError: 'Nie udało się zapisać BLIKa!'
      }
    },
    creditcard: {
      header: 'Karta płatnicza',
      loadingText: 'Wczytywanie danych...',
      verifyText: 'W celu weryfikacji karty pobierzemy z Twojego konta 1 zł, a gdy weryfikacja przebiegnie pomyślnie, zwrócimy ją.',
      iframeValidationError: 'Podane dane są nieprawidłowe',
      iframeValidationSuccess: 'Podane dane są prawidłowe',
      descriptionText: 'Aby zrealizować to zamówienie, potrzebujemy Twoich danych. Poprzez kliknięcie „Zapłać”, decydujesz się na przekazanie nam ich. Administratorem Twoich danych osobowych jest Autopay z siedzibą na ul. Powstańców Warszawy 6 , 81-718. Informacje o podstawie prawnej, celu i okresie, w którym będziemy przechowywać twoje dane oraz uprawnieniach, które Ci (jako Użytkownikowi) przysługują, znajdziesz w <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Polityce prywatności Autopay S.A.</a>',
      buttonNext: 'Zapłać',
      messges: {
        addTokenErrorHeader: 'Błąd!',
        addTokenError: 'Nie udało się zapisać danych karty!'
      }
    },
    progress: {
      step1: 'Numer telefonu i&nbsp;<span>e-mail</span>',
      step2: 'Kwota doładowania',
      step3: 'Podsumowanie i&nbsp;płatność'
    },
    stage1: {
      formErrorHeader: 'Popraw błędy formularza',
      formErrorPhone: 'Podaj choć jeden numer telefonu do doładowania.',
      formErrorEmail: 'Podaj poprawny adres e-mail.',
      formErrorCheckphone: 'Numer {phone} nie może być doładowany.',
      title: '<strong>Krok 1</strong> - Numer telefonu i e-mail',
      header: 'Podaj numer telefonu i adres e-mail',
      labelPhone: 'Numer telefonu, który chcesz doładować',
      errorPhoneRequired: 'Numer telefonu jest wymagany',
      errorPhoneInvalid: 'Numer telefonu jest nieprawidłowy',
      errorPhoneCheck: 'Numer telefonu nie może być doładowany',
      labelEmail: 'Adres e-mail',
      placeholderEmail: 'podaj adres e-mail',
      errorEmailRequired: 'Adres e-mail jest wymagany',
      errorEmailInvalid: 'Adres e-mail jest nieprawidłowy',
      emailDescription: 'Na ten adres e-mail wyślemy potwierdzenie doładowania.',
      addPhone: 'Dodaj kolejny numer',
      addPhoneMaxInfo: '(max. {count} numerów)',
      required: 'pola wymagane',
      buttonNext: 'Dalej',
      maintenanceHeader1: 'Trwa przerwa techniczna.',
      maintenanceHeader2: 'Zapraszamy 28.05.2020 od godziny 08:00.',
      headerLogged1: 'Wybierz numer z listy',
      headerLogged2: 'lub wprowadź numer do doładowania',
      loadingText: 'Pobieranie danych...',
      contactCheckphoneError: 'Numer nie może być obecnie doładowany!',
      a11y: {
        addNumberButton: 'Pokaż kolejne pole dla wpisania numeru telefonu',
        removeNumberButton: 'Usuń pole numeru telefonu',
        chooseNumberButton: 'Wybierz ten numer telefonu',
        unselectNumberButton: 'Odznacz ten numer telefonu'
      }
    },
    stage2: {
      title: '<strong>Krok 2</strong> - Kwota doładowania',
      header: 'Kwota doładowania dla&nbsp;numeru <span>{phone}</span>',
      headerLogged: 'Kwota doładowania dla <span>{contactName}</span>',
      advTitle: 'Zyskaj ekstra doładowanie!',
      advText: 'Doładuj konto 4 razy dowolną kwotą, a zyskasz extra środki bonusowe',
      advLink: 'Regulamin promocji',
      recommend: 'Polecane!',
      otherAmount: 'inna<br>kwota',
      messageAmountMin: 'Podana kwota została zmieniona, ponieważ minimalna kwota doładowania&nbsp;to&nbsp;<strong>{amount}&nbsp;zł</strong>.',
      messageAmountMax: 'Podana kwota została zmieniona, ponieważ maksymalna kwota doładowania&nbsp;to&nbsp;<strong>{amount}&nbsp;zł</strong>.',
      buttonBack: 'Wróć',
      buttonNext: 'Dalej',
      saveContact: 'Dodaj do książki odbiorców',
      setReminder: 'Przypomnij o doładowaniu',
      setReminderIn: 'za',
      setReminderDays: 'dni',
      placeholderContactName: 'nazwa odbiorcy',
      a11y: {
        advLink: 'Przejdź do dokuemntu pdf z Regulaminem doładowania'
      }
    },
    stage3: {
      title: '<strong>Krok 3</strong> - Podsumowanie i płatność',
      header: 'Podsumowanie',
      loadingText: 'Przetwarzanie danych...',
      topupErrorHeader: 'Podczas przetwarzania doładowania wystapił błąd!',
      topupErrorText: 'Spróbuj ponownie lub skonsultuj się z pomocą techniczną.',
      labelPhone: 'Numer telefonu',
      labelAmount: 'Kwota',
      labelEmail: 'Adres e-mail',
      checkAll: 'Zaznacz wszystkie zgody',
      agreementText: '<span class="red">*</span> Zapoznałem się i akceptuję <a href="/files/plus/Regulamin-doladowan-PLUS.pdf" target="_blank" rel="noreferrer" title="Przejdź do strony z dokumentem pdf Regulamin doładowań PLUS">Regulamin doładowań telefonów komórkowych</a> oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer" title="Przejdź do strony z dokumentem pdf Polityka prywatności">Politykę&nbsp;prywatności</a>',
      paymentText: '<span class="red">*</span> Chcę, aby usługa została zrealizowana niezwłocznie i przyjmuję do wiadomości, że w przypadku pełnego wykonania usługi, z chwilą jej wykonania, utracę prawo do odstąpienia od umowy.',
      marketingText: 'Chcę otrzymywać od Autopay S.A. albo jej Partnerów mailowe lub telefoniczne informacje o promocjach, konkursach i innych ciekawych wydarzeniach organizowanych przez Autopay. Wiem, że Autopay nie będzie mnie spamować niepotrzebnymi informacjami, i że w każdej chwili mogę wycofać swoją zgodę.',
      rodoText: 'Administratorem danych osobowych jest Autopay S.A. ul. Powstańców Warszawy 6, 81-718 Sopot. Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji płatności. Podstawa prawna, cel, okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje dotyczące zasad przetwarzania danych osobowych są szczegółowo określone w <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer" title="Przejdź do strony z dokumentem pdf Polityka prywatności">Polityce prywatności Autopay S.A.</a>',
      buttonBack: 'Wróć',
      buttonNext: 'Zamawiam i płacę',
      required: 'pole wymagane'
    },
    footer: {
      linkTerms: 'Regulamin usługi',
      linkTermsPromo1: 'Regulamin promocji "4 doładowania i gratis"',
      linkTermsAuto: 'Regulamin doładowań cyklicznych',
      linkInvoice: 'Faktura za doładowanie',
      linkFaq: 'Najczęściej zadawane pytania',
      registerSim: 'Zarejestruj kartę SIM',
      copyrights: '© {year} Polkomtel Sp. z o.o. Wszelkie&nbsp;prawa&nbsp;zastrzeżone',
      menu: {
        linkAboutUs: 'O firmie',
        linkContact: 'Kontakt',
        linkPress: 'Biuro prasowe',
        linkNews: 'Komunikaty',
        linkJob: 'Praca',
        linkPrivacyPolicy: 'Polityka Prywatności',
        linkSiteMap: 'Mapa strony'
      }
    },
    contacts: {
      loadingText: 'Pobieranie danych...',
      addContact: 'Dodaj kontakt',
      form: {
        labelName: 'Nazwa',
        errorName: 'Nazwa kontaktu jest wymagana',
        labelPhone: 'Numer telefonu',
        errorPhoneRequired: 'Numer telefonu jest wymagany',
        errorPhoneInvalid: 'Numer telefonu jest nieprawidłowy',
        errorPhoneCheck: 'Numer telefonu nie może być doładowany',
        errorPhoneNotUnique: 'Numer telefonu jest już w Kontaktach',
        tooltipButtonSave: 'Zapisz',
        tooltipButtonCancel: 'Anuluj'
      },
      list: {
        emptyText: 'Brak danych',
        labelName: 'Nazwa',
        labelPhone: 'Telefon',
        labelAutotopup: 'Doładowanie cykliczne',
        labelPaymentMethod: 'Źródło płatności',
        paymentMethodBlik: 'BLIK',
        paymentMethodCard: 'Karta płatnicza',
        tooltipButtonEdit: 'Edycja',
        tooltipButtonDelete: 'Usuń',
        tooltipButtonTopup: 'Doładuj',
        topupPeriodConditions: '{amount} zł co {day} dni',
        topupPeriodNextDate: 'Data doładowania:',
        topupDayConditions: '{amount} zł każdego {day} dnia mies.',
        topupButtonAdd: 'Kliknij, by dodać',
        a11y: {
          topupButtonAdd: 'Przejdź do strony konfikguracji doładowania',
          topupButton: 'Przejdź do strony doładowania',
          topupButtonEdit: 'Otwórz widok edycji kontaktu'
        }
      },
      messges: {
        removeHeader: 'Uwaga!',
        removeConfirm: 'Czy na pewno usunąć kontakt?',
        removeConfirmButton: 'Usuń',
        removeCancelButton: 'Anuluj',
        removeSuccess: 'Kontakt został usunięty!',
        removeError: 'Nie udało się usunąć kontaktu.',
        phoneVerifyHeader: 'Błąd!',
        phoneVerifyError: 'Podczas weryfikacji numeru telefonu wystąpił błąd.',
        addContactSuccess: 'Kontakt został dodany.',
        addContactErrorHeader: 'Błąd!',
        addContactError: 'Nie udało się dodać kontaktu.',
        updateContactSuccess: 'Kontakt został uaktualniony.',
        updateContactErrorHeader: 'Błąd!',
        updateContactError: 'Nie udało się uaktualnić kontaktu.'
      }
    },
    contactsEdit: {
      header: 'Edycja kontaktu',
      buttonBack: 'Anuluj',
      buttonNext: 'Zapisz',
      buttonPaymentTypeBlik: 'BLIK',
      buttonPaymentTypeCard: 'Karta płatnicza',
      autotopupHeader: 'Doładowanie cykliczne',
      paymentMethodHeader: 'Rodzaj płatności',
      contactButtonDelete: 'Usuń kontakt',
      autotopupButtonDelete: 'Usuń doładowanie cykliczne',
      autotopupButtonAdd: 'Dodaj doładowanie cykliczne',
      messges: {
        updateAutotopupSuccess: 'Twoje doładowanie cykliczne zostało uaktualnione!',
        updateAutotopupError: 'Nie udało się uaktualnić danych doładowania cyklicznego!',
        removeHeader: 'Uwaga!',
        removeConfirm: 'Czy na pewno usunąć doładowanie cykliczne?',
        removeConfirmButton: 'Usuń',
        removeCancelButton: 'Anuluj',
        removeSuccess: 'Twoje doładowanie cykliczne zostało usunięte!',
        removeError: 'Nie udało się usunąć doładowania cyklicznego.',
        updateContactSuccess: 'Kontakt został uaktualniony!',
        updateContactError: 'Nie udało się uaktualnić danych kontaktu!'
      },
      a11y: {
        autotopupButtonAdd: 'Przejdź do strony konfikguracji doładowania',
        buttonBack: 'Anuluj zmiany i przejdź do strony kontaktów',
        buttonNext: 'Zachowaj zmiany i przejdź do strony kontaktów',
        buttonPaymentTypeCard: 'Wybierz jako rodzaj płatności kartę płatniczą',
        buttonPaymentTypeBlik: 'Wybierz jako rodzaj płatności Blik'
      }
    },
    history: {
      filter: {
        labelDateStart: 'Data początkowa',
        labelDateEnd: 'Data końcowa',
        errorDateStart: 'Podaj poprawną datę początkową',
        errorDateEnd: 'Podaj poprawną datę końcową',
        buttonSearch: 'Szukaj'
      },
      list: {
        emptyText: 'Brak danych w historii doładowań',
        labelPaymentDate: 'Data',
        labelTopupAmount: 'Kwota',
        labelTopupType: 'Typ',
        labelPhoneNumber: 'Numer',
        labelPaymentId: 'ID',
        labelPaymentStatus: 'Status',
        labelTopupStatus: 'Doładowanie',
        paymentStatusOk: 'opłacona',
        paymentStatusWait: 'oczekująca',
        paymentStatusError: 'błąd płatności',
        topupStatusOk: 'zrealizowane',
        topupStatusWait: 'oczekujące',
        topupStatusError: 'błąd doładowania',
        tooltipTopupAgain: 'Doładuj ponownie',
        tooltipTopupSingle: 'Doładowanie jednorazowe',
        tooltipTopupAuto: 'Doładowanie cykliczne',
        a11y: {
          pageSizeSelect: 'Zmień liczbę wyswietlanych rekordów',
          topupButton: 'Przejdź do strony doładowania'
        }
      }
    },
    userData: {
      account: {
        header: 'Konto użytkownika',
        labelEmail: 'E-mail:',
        labelPassword: 'Hasło:',
        buttonRemoveAccount: 'Usuń konto',
        messages: {
          removeHeader: 'Uwaga!',
          removeConfirm: 'Czy na pewno chcesz usunąć swoje konto?',
          removeConfirmButton: 'Usuń',
          removeCancelButton: 'Anuluj',
          removeSuccess: 'Twoje konto zostało usunięte.',
          removeError: 'Nie udało się usunąć konta!'
        },
        a11y: {
          buttonEditAccount: 'Przejdź do widoku edycji danych użytkownika'
        }
      },
      payment: {
        header: 'Metody płatności cyklicznych',
        description: 'Dodaj metodę płatności, aby opłacać doładowania cykliczne. W każdej chwili możesz usunąć metody płatności lub zmienić sposób opłacania doładowań cyklicznych dla poszczególnych numerów telefonu. Jeżeli nie masz aktywnej metody płatności, usługa doładowań cyklicznych jest wyłączona.',
        labelStatus: 'Status:',
        labelType: 'Metoda płatności:',
        labelCardNumber: 'Numer karty',
        labelCardValidity: 'Data ważności:',
        creditCardType: 'Karta płatnicza',
        blikType: 'Płatności potwarzalne BLIK',
        blikValidity: 'bezterminowa',
        blikNumber: 'nie dotyczy',
        statusActive: 'AKTYWNA',
        statusInactive: 'NIEAKTYWNA',
        statusPending: 'TRWA AKTYWACJA',
        statusFailure: 'BŁĄD AKTYWACJI',
        buttonAddCreditCard: 'Dodaj kartę płatniczą',
        buttonAddBlik: 'Dodaj płatność powtarzalną BLIK',
        buttonRemoveCreditCard: 'Usuń',
        buttonRemoveBlik: 'Usuń',
        messages: {
          removeHeader: 'Uwaga!',
          removeConfirm: 'Czy na pewno chcesz usunąć wybraną metodę płatności? Bez źródła płatności doładowania cykliczne nie mogą być realizowane.',
          removeConfirmButton: 'Usuń',
          removeCancelButton: 'Anuluj',
          removeSuccess: 'Metoda płatności została usunięta.',
          removeError: 'Nie udało się usunąć metody płatności!'
        },
        a11y: {
          buttonRemoveMethod: 'Usuń z listy metodę płatności cyklicznej'
        }
      }
    }
  },
  globalMessages: {
    userSessionTimeOut: 'Ze względów bezpieczeństwa zostałeś automatycznie wylogowany. Zaloguj się ponownie.'
  }
}
